export default __webpack_public_path__ + "static/media/ours.8c4e99d8.png";